export interface JournalPinJumpToModel {
  pinLocation: string;
  quadrantId: string;
  styleId: number;
}
